import React, { useState } from "react";
import { Box, Button, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./style";

const EMPTY_FILTERS = { department: "", role: "", startDate: "", endDate: "" };

// Department / role / joining-date filters shown inside the SubHeader "Filter" menu.
// Selects render without a portal so picking an option doesn't trigger the menu's click-away.
const FilterPanel = ({ departmentData, roleData, listFilters, onApply, onClose }) => {
  const [draft, setDraft] = useState({ ...EMPTY_FILTERS, ...listFilters });
  const isDateRangeInvalid = !!(draft.startDate && draft.endDate && draft.startDate > draft.endDate);

  const handleDraftChange = (key, value) => {
    setDraft((prev) => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    onApply(draft);
    onClose();
  };

  const handleClear = () => {
    setDraft(EMPTY_FILTERS);
    onApply(EMPTY_FILTERS);
    onClose();
  };

  return (
    <Box sx={styles.filterPanel}>
      <InputLabel sx={styles.filterPanelLabel}>Department</InputLabel>
      <Select
        size="small"
        fullWidth
        displayEmpty
        value={draft.department}
        onChange={(e) => handleDraftChange("department", e.target.value)}
        MenuProps={{ disablePortal: true }}
        sx={styles.filterPanelInput}
      >
        <MenuItem value="">All departments</MenuItem>
        {departmentData?.map((item, index) => (
          <MenuItem key={index} value={item?.name}>{item?.name}</MenuItem>
        ))}
      </Select>

      <InputLabel sx={styles.filterPanelLabel}>Role</InputLabel>
      <Select
        size="small"
        fullWidth
        displayEmpty
        value={draft.role}
        onChange={(e) => handleDraftChange("role", e.target.value)}
        MenuProps={{ disablePortal: true }}
        sx={styles.filterPanelInput}
      >
        <MenuItem value="">All roles</MenuItem>
        {roleData?.map((item, index) => (
          <MenuItem key={index} value={item?.name}>{item?.name}</MenuItem>
        ))}
      </Select>

      <InputLabel sx={styles.filterPanelLabel}>Joining date from</InputLabel>
      <TextField
        size="small"
        fullWidth
        type="date"
        value={draft.startDate}
        onChange={(e) => handleDraftChange("startDate", e.target.value)}
        inputProps={{ max: draft.endDate || undefined }}
        sx={styles.filterPanelInput}
      />

      <InputLabel sx={styles.filterPanelLabel}>Joining date to</InputLabel>
      <TextField
        size="small"
        fullWidth
        type="date"
        value={draft.endDate}
        onChange={(e) => handleDraftChange("endDate", e.target.value)}
        inputProps={{ min: draft.startDate || undefined }}
        error={isDateRangeInvalid}
        helperText={isDateRangeInvalid ? "End date must be after start date" : ""}
        sx={styles.filterPanelInput}
      />

      <Box sx={styles.filterPanelActions}>
        <Button size="small" onClick={handleClear} sx={styles.filterPanelClear}>
          Clear
        </Button>
        <Button size="small" variant="contained" onClick={handleApply} disabled={isDateRangeInvalid} sx={styles.filterPanelApply}>
          Apply
        </Button>
      </Box>
    </Box>
  );
};

export default FilterPanel;
